class SearchDetails {
    searchValue = "";
}

export default SearchDetails;